import axios from 'axios';
import qs from 'qs';
import {isIOS12} from './util';

const instance = axios.create();
// 发送请求前做特殊处理
instance.interceptors.request.use(
    function (config) {
        // Do something before request is sent
        config.params = config.params || {};
        config.data = config.data || {};
        if (config.rawFormData !== false) {
            // 默认支持 rawFormData
            config.data = qs.stringify(config.data);
        }
        return config;
    },
    function () {
        // Do something with request error
    }
);

export function postData(resolve, reject, reportUrl, reportData) {
    const value = encodeURIComponent(JSON.stringify(reportData));

    if (window.navigator.sendBeacon && !isIOS12() && window.URLSearchParams) {
        const searchParams = new URLSearchParams({
            data: value
        });

        try {
            // https://stackoverflow.com/questions/45847276/navigator-sendbeacon-with-application-x-www-form-urlencoded
            window.navigator.sendBeacon(reportUrl, searchParams);
            resolve();
        } catch (e) {
            reject(e);
        }
    } else {
        instance
            .post(reportUrl, {
                data: value
            })
            .then(() => {
                resolve();
            })
            .catch(reject);
    }
}
